var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    color: "#5A5F60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 27.5V5C7.5 4.6625 7.5 4.3125 7.5875 3.975C7.66401 3.63828 7.83341 3.32977 8.07647 3.08451C8.31952 2.83924 8.62649 2.66705 8.9625 2.5875C9.325 2.5 10.9125 2.5 11.25 2.5H20C20.3375 2.5 20.6875 2.5 21.025 2.5875C21.3617 2.66401 21.6702 2.83341 21.9155 3.07647C22.1608 3.31952 22.3329 3.62649 22.4125 3.9625C22.5 4.3125 22.5 4.6625 22.5 5V27.5H7.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50009 17.5V25C2.50009 26.375 3.62509 27.5 5.00009 27.5H7.50009V15H5.00009C4.66259 15 4.31259 15 3.97509 15.0875C3.63759 15.175 3.32509 15.3375 3.07509 15.5875C2.83759 15.825 2.67509 16.1375 2.58759 16.475C2.51703 16.8119 2.48765 17.1561 2.50009 17.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.025 11.3383C25.6881 11.2678 25.3439 11.2384 25 11.2508H22.5V27.5008H25C25.663 27.5008 26.2989 27.2374 26.7678 26.7686C27.2366 26.2998 27.5 25.6639 27.5 25.0008V13.7508C27.5 13.4008 27.5 13.0633 27.4125 12.7258C27.325 12.3883 27.1625 12.0758 26.9125 11.8258C26.675 11.5883 26.3625 11.4258 26.025 11.3383Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5H17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5H17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.5H17.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.08315ef101d7325b893232b1c8ddedb6.svg";
export { ForwardRef as ReactComponent };